import React from "react";

interface Props {
	className?: string;
	type?: string;
}

const Loader: React.FC<Props> = ({ className, type }) => {
	if (type === "circle") {
		return (
			<div className={"lds-ring-container " + (className || "")}>
				<div className="lds-ring">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		);
	}
	return (
		<div className={"loader " + (className || "")}>
			<div className="loader-1"></div>
			<div className="loader-2"></div>
			<div className="loader-3"></div>
		</div>
	);
};
export default Loader;
